export const norwegian = {
  lang: 'nb',
  data: {
    titles: {
      course: 'Kurs',
      course_overview: 'Om kurstypene',
      classroom_course: 'Fysiske kurs',
      digital_course: 'Digitale kurs',
      provider_course: 'Kurs fra tilbydere',
      about: 'Om',
      course_content: 'Kursinnhold',
      course_request: 'Savner du et kurs?'
    },
    subtitles: {
      course_overview: 'Her finner du oversikt over alle fysiske og digitale kurs som tilbys på RS Sjøliv. De fysiske kursene blir levert av eksterne instruktører som alle er verifisert av Redningsselskapet. Fra 1. juni i år må du ha Høyhastighetsbevis dersom du skal føre en båt som kan gå over 50 knop.',
      classroom_course: 'Kursene på RS Sjøliv blir levert av selvstendige instruktører. For å bli instruktør må man bli verifisert av RS. Ønsker du å tilby kurs?',
      digital_course: ' Med våre digitale kurs kan du lære hvor og når du vil!',
      provider_course: 'Kursene på RS Sjøliv blir levert av selvstendige instruktører. For å bli instruktør må man bli verifisert av RS.',
      course_request: 'Her kan du legge inn hvilke(t) type kurs du ønsker, hvor i landet du ønsker det og eventuelt instruktør. Denne informasjonen vil bli sendt til aktuelle instruktører når fire personer eller flere ønsker det samme kurset som deg. Om det blir satt opp et kurs som passer dine ønsker vil vi sende deg en e-post om dette.'
    },
    action_buttons: {
      save:'Lagre',
      clear: 'Tøm filter',
      see_course: 'Se kurs',
      template_send_request: 'Savner du et kurs?',
      send_request: 'Send inn forespørsel',
    },
    course_request_form: {
      name: {
        label: 'Navn',
        placeholder: 'Navn'
      },
      email: {
        label: 'E-post',
        placeholder: 'E-post'
      },
      confirm_email: {
        label: 'Bekreft e-post',
        placeholder: 'E-post'
      },
      wanted_course: {
        label: 'Hvilke(t) kurs ønsker du',
        placeholder: 'Velg kurs'
      },
      region: {
        label: 'Velg område',
        placeholder: 'Velg område'
      },
      comment: {
        label: 'Kommentar',
        placeholder: 'Send gjerne med en kommentar'
      }
    },
    availableSlots: 'tilgjengelige kursdatoer',
    availableSlot: 'tilgjengelig kursdato',
    noSlot: 'Ingen tilgjengelige kursdatoer',
    duration: 'Varighet',
    hour: 'time',
    hours: 'timer',
    availableCourses: 'Tilgjengelige kurs',
    description: 'Beskrivelse',
    exam: 'Eksamen',
    practical_part: 'Praktisk del',
    yes: 'Ja',
    no: 'Nei',
    course: 'Kurs',
    region: 'Region',
    reset: 'Nullstill',
    date: 'Dato',
    search: 'SØK',
    no_course_available: 'Ingen kurs tilgjengelig ennå',
    rs_member: 'RS-medlem',
    rs_non_member: 'Pris',
    read_more: 'Les mer',
    read_more_here: 'Les mer her',
    read_more_about_evidence_here: 'Les mer om beviset her.',
    read_less: 'Les mindre',
    notifications: {
      course_request_success: 'Din forespørsel er mottatt'
    }
  },
};
